var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "menu-panel",
      class: { "is-sheet": _vm.variant === "sheet" },
      attrs: { "aria-label": _vm.$t("assistantCatHome.openMenu") },
    },
    _vm._l(_vm.sections, function (section, sectionIndex) {
      return _c(
        "div",
        { key: sectionIndex, staticClass: "menu-panel__section" },
        _vm._l(section, function (item) {
          return _c(
            "div",
            { key: item.action, staticClass: "menu-panel__item" },
            [
              _c(
                "button",
                {
                  staticClass: "menu-panel__main",
                  class: {
                    "menu-panel__main--with-trailing-action": Boolean(
                      _vm.trailingActionOf(item)
                    ),
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("action", item.action)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "menu-panel__label" }, [
                    _vm._v(
                      _vm._s(_vm.$t(`assistantCatHome.menu.${item.action}`))
                    ),
                  ]),
                  !_vm.trailingActionOf(item)
                    ? _c(
                        "span",
                        { staticClass: "menu-panel__trailing" },
                        [
                          item.trailing === "catThumbnail"
                            ? _c("cat-icon", {
                                staticClass: "menu-panel__cat",
                                attrs: {
                                  size: "small",
                                  clickable: false,
                                  "writer-type": _vm.writerType,
                                },
                              })
                            : _c("icon-chevron-right", {
                                staticClass: "menu-panel__chevron",
                              }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm.trailingActionOf(item)
                ? _c(
                    "button",
                    {
                      staticClass: "menu-panel__trailing-button",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t(
                          `assistantCatHome.menu.${_vm.trailingActionOf(item)}`
                        ),
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.$emit("action", _vm.trailingActionOf(item))
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "menu-panel__mode-icon",
                        attrs: { src: _vm.trailingIconSrc(item), alt: "" },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }